import { AvailableTemplate, PowerpointExportDto, PowerpointSlide, PowerpointSlideType } from '@ecosystem/export-api';
import { ImageURLData } from '@ecosystem/export-utils';
import { GetExportImagePowerPointParams, GetExportMultiImagePowerPointParams } from './Model';
import { getContextPowerPoint, getDateTime } from './ExportUtils';
import { ExportContext, PageName } from '@utils/pageConfig/Types';
import { SortDirection } from '@components/design/migrated/Table/Sorting/types';
import { startCase } from 'lodash';

export const getChartExportPowerPoint = (params: GetExportImagePowerPointParams): PowerpointExportDto => {
  const {
    appliedCountry,
    appliedPg,
    timePeriod,
    comparisonTimePeriod,
    periodType,
    showPerformanceWithin,
    appliedFiltersText,
    pageName,
    pagesConfig,
    loadedProductGroups,
    filename,
    imageData,
    title,
    subTitle,
    loadedCountries,
  } = params;

  const exportContext: ExportContext = {
    appliedCountry: appliedCountry,
    appliedPg: appliedPg,
    timePeriod: timePeriod,
    comparisonTimePeriod: comparisonTimePeriod,
    periodType: periodType,
    showPerformanceWithin: showPerformanceWithin,
    appliedFiltersText: appliedFiltersText,
    pageName: pageName,
    pagesConfig: pagesConfig,
    loadedProductGroups: loadedProductGroups,
    loadedCountries: loadedCountries,
  };
  return {
    template: AvailableTemplate.Powerpoint,
    name: filename,
    userDateTimeIso8601: getDateTime(),
    context: getContextPowerPoint(exportContext),
    slides: [getPowerPointSlide(imageData, title, subTitle)],
  };
};
export const getMultiChartExportPowerPoint = (params: GetExportMultiImagePowerPointParams): PowerpointExportDto => {
  const {
    appliedCountry,
    appliedPg,
    timePeriod,
    comparisonTimePeriod,
    periodType,
    showPerformanceWithin,
    appliedFiltersText,
    selectedKpi,
    sortedBy,
    pageName,
    pagesConfig,
    loadedProductGroups,
    chartTitles,
    chartSubTitles,
    loadedCountries,
  } = params;

  const kpi = selectedKpi?.label === 'Select' ? '' : selectedKpi?.label;
  const sorted =
    sortedBy && `${sortedBy?.label} (${sortedBy?.sortDirection === SortDirection.desc ? 'Descending' : 'Ascending'})`;
  const getSortedByValue = pageName === PageName.TRADING_ASSISTANT ? startCase(sortedBy) : sorted;

  const exportContext: ExportContext = {
    appliedCountry: appliedCountry,
    appliedPg: appliedPg,
    timePeriod: timePeriod,
    comparisonTimePeriod: comparisonTimePeriod,
    periodType: periodType,
    showPerformanceWithin: showPerformanceWithin,
    appliedFiltersText: appliedFiltersText,
    pageName: pageName,
    pagesConfig: pagesConfig,
    selectedKpi: kpi,
    sortedBy: getSortedByValue,
    loadedProductGroups,
    loadedCountries,
  };

  const slides = params?.imageData?.map((image, index) => {
    return getPowerPointSlide(image, chartTitles[index], chartSubTitles?.[index]);
  });

  return {
    template: AvailableTemplate.Powerpoint,
    name: params.filename,
    userDateTimeIso8601: getDateTime(),
    context: getContextPowerPoint(exportContext),
    slides,
  };
};

export const getPowerPointSlide = (imageData: ImageURLData, title: string, subTitle: string): PowerpointSlide => {
  return {
    title: title,
    subtitle: subTitle,
    type: PowerpointSlideType.Image,
    image: imageData,
  };
};
